// @noflow
import * as React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { LoadingIndicator } from '~/components/widgets';

import { Base, Container, Overlay, ResetSchedule, Resize } from './style';
import messages from '~/core/domains/schedule/intl';
import MessagesBar from './messages-bar';
import PickerContainer from './picker-container';
import SVGContainer from './svg-container';
import Tooltip from './tooltip';

Schedule.propTypes = {
    componentId: PropTypes.string.isRequired,
    isSavingSchedule: PropTypes.bool.isRequired,
    isScheduleLoaded: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired
};

export default function Schedule({ componentId, isSavingSchedule, isScheduleLoaded, reset, style }) {
    return (
        <LoadingIndicator isLoading={!isScheduleLoaded}>
            <Base data-qa="schedule-base" style={style}>
                <MessagesBar componentId={componentId} />
                <Resize>
                    {({ height, width }) =>
                        height > 0 && width > 0 ? (
                            <Container role="presentation">
                                <SVGContainer componentId={componentId} height={height} width={width} />
                                <Tooltip componentId={componentId} height={height} width={width} />
                                <PickerContainer componentId={componentId} height={height} width={width} />
                            </Container>
                        ) : (
                            <span />
                        )}
                </Resize>
                <ResetSchedule data-qa="schedule-reset" onClick={reset}>
                    <FormattedMessage {...messages.resetSchedule} />
                </ResetSchedule>
                <Overlay show={isSavingSchedule}>
                    <FormattedMessage {...messages.savingSchedule} />
                </Overlay>
            </Base>
        </LoadingIndicator>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/component.js